// The timeline's registrations (lane B10 S18; loaded by views/b10/register.ts; lane contract C-B10-13). B10's one event
// list (TimelineList over `timeline.view`) is the body of the two timeline tabs the owning lanes left as slots: lane B2's
// Requisition timeline tab (`registerTimelineBody`; B2 keeps the Activity link under it) and lane B3's Candidate
// timeline tab on the profile (`registerProfileTimelineBody`). Each slot admits one body; the tabs, their routes and
// their gates stay the owning lanes'.

import { createElement } from "react";
import { HISTORY_LABELS } from "@/mc";
import { registerProfileTimelineBody, type ProfileTimelineBodyProps } from "@/views/candidate/slots";
import { registerTimelineBody, type TimelineBodyProps } from "@/views/requisition/slots";
import { TimelineList } from "./TimelineList";

function RequisitionTimelineBody({ r }: TimelineBodyProps) {
  return createElement(TimelineList, { subject: "requisition", id: r.id, title: HISTORY_LABELS.requisitionTimeline });
}

function CandidateTimelineBody({ candidateId }: ProfileTimelineBodyProps) {
  return createElement(TimelineList, { subject: "candidate", id: candidateId, title: HISTORY_LABELS.candidateTimeline });
}

registerTimelineBody({ key: "b10-timeline", lane: "B10", component: RequisitionTimelineBody });
registerProfileTimelineBody({ key: "b10-timeline", lane: "B10", component: CandidateTimelineBody });
